const initial_state = {
  zatca_metadata: null,
  tax_configuration: {
    taxationEnabled: true,
    taxationType: "zatca_phase_2",
  },
};
const zatcaInfoReducer = (state = initial_state, action) => {
  switch (action.type) {
    case "ZATCA_METADATA":
      console.log(action);
      return Object.assign({}, state, {
       zatca_metadata: action.zatca_metadata,
      });
    case "TAX_CONFIGURATION":
      return {
        ...state,
        tax_configuration: action.tax_configuration,
      };
    case "PUT_RECEIPT_METADATA":
      return {
        ...state,
        receipt_metadata: action.receipt_metadata,
      };

    case "CLEAR_COMPANY_INFO":
      return initial_state;

    default:
      return state;
  }
};

export default zatcaInfoReducer;
